import { FC } from 'react';
import { usePathContext } from '@new/common/hooks/usePathContext';
import { Can } from '@new/casl';
import { DegreePageProvider } from '../contexts/DegreePageContext';
import { useDegreePageContext } from '../contexts/DegreePageContext';
import { EditButton } from '@new/common/ui/EditButton/EditButton';
import { DegreeCourseList } from '../components/Course/DegreeCourseList';
import { DegreeVideo } from '../components/Degree/DegreeVideo/DegreeVideo';
import { DegreeDescription } from '../components/Degree/DegreeDescription/DegreeDescription';
import { Loader } from '@new/common/ui/Loader/Loader';
import { PageHeader } from '@new/common/ui/PageHeader/PageHeader';

export const SingleDegreePage: FC = () => {
  const { degreeId = 0 } = usePathContext();

  return (
    <DegreePageProvider degreeId={degreeId}>
      <SingleDegreePageContent />
    </DegreePageProvider>
  );
};

const SingleDegreePageContent: FC = () => {
  const { degree, isLoading, degreeId } = useDegreePageContext();

  if (isLoading) {
    return <Loader />;
  }

  if (!degree) {
    return (
      <div className="w-full h-full flex items-center justify-center">
        <p>Degree not found</p>
      </div>
    );
  }

  return (
    <div className="flex min-h-full w-full min-w-0 flex-col gap-6 p-6 lg:p-8 pt-0!">
      <PageHeader
        title={degree.name}
        description={degree.shortDescription}
        badge={{
          text: 'Degree',
          bgColor: 'var(--tertiary-Y100)',
          textColor: 'var(--tertiary-Y500)',
        }}
      />
      <Can I="update" a="Degree">
        <EditButton path={`/degrees/${degreeId}/edit`} />
      </Can>
      <div className="flex w-full min-w-0 flex-col gap-6">
        {degree.introVideo && <DegreeVideo url={degree.introVideo} />}
        <DegreeDescription
          longDescription={degree.longDescription}
          shortDescription={degree.shortDescription}
          goals={degree.goals}
        />
      </div>
      <div className="flex w-full flex-col items-start gap-2.5 rounded-xl border-2 border-(--neutral-black-NB100) bg-(--neutral-white-NW1000) p-4 md:p-6 lg:p-8">
        <DegreeCourseList />
      </div>
    </div>
  );
};
